function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalOutflowBaas({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#F8EBEA",
    style: {
      fill: "#F8EBEA",
      fill: "color(display-p3 0.9725 0.9216 0.9176)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0834 23.0417C18.0834 24.1734 18.9584 25.0834 20.0317 25.0834H22.225C23.1584 25.0834 23.9167 24.29 23.9167 23.2984C23.9167 22.2367 23.4501 21.8517 22.7617 21.6067L19.25 20.3817C18.5617 20.1367 18.0951 19.7634 18.0951 18.69C18.0951 17.71 18.8534 16.905 19.7867 16.905H21.98C23.0534 16.905 23.9284 17.815 23.9284 18.9467",
    stroke: "#961D14",
    style: {
      stroke: "#961D14",
      stroke: "color(display-p3 0.5882 0.1144 0.0784)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15.75V26.25",
    stroke: "#961D14",
    style: {
      stroke: "#961D14",
      stroke: "color(display-p3 0.5882 0.1144 0.0784)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 21C32.6667 27.44 27.44 32.6666 21 32.6666C14.56 32.6666 9.33337 27.44 9.33337 21C9.33337 14.56 14.56 9.33331 21 9.33331",
    stroke: "#961D14",
    style: {
      stroke: "#961D14",
      stroke: "color(display-p3 0.5882 0.1144 0.0784)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 14V9.33331H28",
    stroke: "#961D14",
    style: {
      stroke: "#961D14",
      stroke: "color(display-p3 0.5882 0.1144 0.0784)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8334 15.1666L32.6667 9.33331",
    stroke: "#961D14",
    style: {
      stroke: "#961D14",
      stroke: "color(display-p3 0.5882 0.1144 0.0784)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOutflowBaas);
export default __webpack_public_path__ + "static/media/total_outflow_baas.e6c76e3d0f077442e729c05882034191.svg";
export { ForwardRef as ReactComponent };